'use strict';

import MinBid from './components/MinBid.vue';

export default class {

    constructor() {
        // Register component globaly
        Vue.component('min-bid', MinBid);

    }
}